import React from "react";
import {
  FaLaptopCode,
  FaUserTie,
  // FaProjectDiagram,
  FaCertificate,
  FaBriefcase,
  // FaUsers,
  FaArrowRight,
} from "react-icons/fa";
import Navbar from "./Navbar";

const programs = [
  "Full Stack Development",
  "React JS",
  "React Native",
  "Python",
  "Java",
  "C & C++",
  "UI/UX Design",
  "PHP",
  "Digital Marketing",
];

const features = [
  {
    icon: <FaLaptopCode size={35} />,
    title: "Live Projects",
    desc: "Hands-on experience with real-world applications.",
  },
  {
    icon: <FaUserTie size={35} />,
    title: "Expert Trainers",
    desc: "Learn from experienced industry professionals.",
  },
  {
    icon: <FaBriefcase size={35} />,
    title: "Placement Support",
    desc: "Resume preparation and interview assistance.",
  },
  {
    icon: <FaCertificate size={35} />,
    title: "Certification",
    desc: "Receive industry-recognized course certificates.",
  },
];

const stats = [
  { number: "500+", title: "Students Trained" },
  { number: "25+", title: "Courses" },
  { number: "95%", title: "Placement Support" },
  { number: "7+", title: "Years Experience" },
];

const Training = () => {
  return (
    <>
        <Navbar/>
      <section className="bg-gray-50">
        {/* Hero */}

        <div className="bg-primary text-white py-24">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-5xl font-bold mb-6">
              Learn Today, Lead Tomorrow
            </h1>

            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Practical, industry-focused training programs designed to make
              students job-ready.
            </p>

            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <button className="bg-white text-primary px-8 py-3 rounded-xl font-semibold hover:scale-105 transition">
                Enroll Now
              </button>

              <button className="border border-white px-8 py-3 rounded-xl font-semibold hover:bg-white hover:text-primary transition">
                Download Brochure
              </button>
            </div>
          </div>
        </div>

        {/* Why Choose */}

        <div className="max-w-7xl mx-auto py-20 px-6">
          <div className="text-center mb-14">
            <h2 className="text-4xl font-bold text-primary">
              Why Choose MSM Technologies?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg p-8 text-center hover:-translate-y-2 transition"
              >
                <div className="text-primary mb-5 flex justify-center">
                  {item.icon}
                </div>

                <h3 className="font-bold text-xl mb-3">{item.title}</h3>

                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Programs */}

        <div className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-center text-primary mb-12">
              Training Programs
            </h2>

            <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-6">
              {programs.map((course, index) => (
                <div
                  key={index}
                  className="border rounded-xl p-5 hover:bg-primary hover:text-white transition cursor-pointer flex justify-between items-center"
                >
                  {course}

                  <FaArrowRight />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Process */}

        <div className="bg-gray-100 py-20">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-center text-primary mb-16">
              Our Training Process
            </h2>

            <div className="grid md:grid-cols-5 gap-6 text-center">
              {[
                "Register",
                "Free Demo",
                "Live Projects",
                "Internship",
                "Placement",
              ].map((step, index) => (
                <div key={index}>
                  <div className="w-20 h-20 bg-primary text-white rounded-full mx-auto flex items-center justify-center text-2xl font-bold">
                    {index + 1}
                  </div>

                  <h3 className="mt-5 font-semibold">{step}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Stats */}

        <div className="py-20 bg-white">
          <div className="max-w-6xl mx-auto grid md:grid-cols-4 gap-8">
            {stats.map((item, index) => (
              <div
                key={index}
                className="text-center bg-gray-50 rounded-2xl shadow-md p-10"
              >
                <h2 className="text-5xl font-bold text-primary">
                  {item.number}
                </h2>

                <p className="mt-3 text-gray-600">{item.title}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}

        <div className="bg-primary text-white py-24">
          <div className="max-w-4xl mx-auto text-center px-6">
            <h2 className="text-5xl font-bold mb-6">
              Ready to Start Your Career?
            </h2>

            <p className="text-xl text-blue-100 mb-10">
              Join MSM Technologies and build the skills employers are looking
              for.
            </p>

            <button className="bg-white text-primary px-10 py-4 rounded-xl font-bold hover:scale-105 transition">
              Enroll Now
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Training;
